import { inject, Injectable } from '@angular/core';
import { Match } from './models/match.model';
import { Category } from './models/category.model';
import { Tournament } from './models/tournament.model';
import { SessionService } from './session.service';
import { GoalUpdate } from './models/match.model';

@Injectable({ providedIn: 'root' })
export class MatchSyncService {
  private readonly sessionService = inject(SessionService);

  applyMatches(matches: readonly Match[]): void {
    for (const match of matches) {
      const existing = this.sessionService.matches().get(match.Id);
      const merged = existing ? { ...existing, ...match } : match;

      this.sessionService.addOrUpdateMatch(merged);
      this.syncCategory(merged);
      this.sessionService.addSport(merged.Sport);
      this.syncTournament(merged);
    }
  }

  applyGoalUpdate(payload: GoalUpdate): void {
    const matchId = payload.MatchID ?? payload.Id;
    const score = payload.NewScore ?? payload.Score;
    if (!matchId || score === null || score === undefined) {
      return;
    }

    this.sessionService.updateMatch(matchId, match => ({
      ...match,
      Live: true,
      Score: score
    }));
  }

  removeBetTypes(betTypeIds: readonly number[]): void {
    this.sessionService.removeBetTypes(betTypeIds);
  }

  private syncCategory(match: Match): void {
    const category: Category = {
      LB_CategoryID: match.LB_CategoryID,
      LB_Category: match.LB_Category,
      LB_CategorySortIndex: match.LB_CategorySortIndex,
      Category: match.Category,
      CountryCode: match.CountryCode,
      Sport: match.Sport
    };

    this.sessionService.addCategory(category);
  }

  private syncTournament(match: Match): void {
    const tournament: Tournament = {
      LB_TournamentID: match.LB_TournamentID,
      LB_TournamentSortIndex: match.LB_TournamentSortIndex,
      Tournament: match.Tournament,
      BrTournamentID: match.BrTournamentID,
      TournamentRating: match.TournamentRating,
      EndDate: match.EndDate,
      Sport: match.Sport
    };

    this.sessionService.addTournament(tournament);
  }
}
